import 'html5-boilerplate/dist/js/plugins.js';
import 'html5-boilerplate/dist/js/vendor/modernizr-3.11.2.min.js';

import ItiSlideshow from './modules/iti-slideshow.js';
import LogoIti from './modules/logo-iti.js';
import MenuHelper from './modules/menu-helper.js';


function syncHeight() {
  document.documentElement.style.setProperty(
    '--window-inner-height',
    `${window.innerHeight}px`
  );
}

document.addEventListener('DOMContentLoaded', () => {
  new LogoIti(document.querySelector('.logo-svg--mobile'), true);
  new LogoIti(document.querySelector('.logo-svg--desktop'));

  new MenuHelper();

  document.querySelectorAll('[data-glide-slideshow]').forEach(el => {
    const slds = new ItiSlideshow(el);
  });

  window.addEventListener('resize', syncHeight);

  /* People page */
  if(document.querySelector('form[name="people-filters"]')) {
    document.querySelectorAll('form[name="people-filters"] select').forEach(el => {
      el.addEventListener('change', () => {
        let params = new URLSearchParams(window.location.search);
        let search = params.get('search') || '';
        let group = params.get('group') || '';
        let domain = params.get('domain') || '';

        if (el.getAttribute('name') == 'search') {
          search = el.value;
        } else if (el.getAttribute('name') == 'domain') {
          domain = el.value;
        } else if (el.getAttribute('name') == 'group') {
          group = el.value;
        }

        const queryParams = new URLSearchParams();
        if (search !== '') {
          queryParams.set('search', search);
        }
        if (group !== '') {
          queryParams.set('group', group);
        }
        if (domain !== '') {
          queryParams.set('domain', domain);
        }

        const link = `${window.location.origin}${window.location.pathname.split('/page/')[0]}?${queryParams.toString()}`;
        window.location.href = link;
      });
    });
  }

  if(document.querySelector('form[name="projects-filters"]')) {
    document.querySelectorAll('form[name="projects-filters"] select, form[name="projects-filters"] input[type="checkbox"]').forEach(el => {
      el.addEventListener('change', () => {
        let params = new URLSearchParams(window.location.search);
        let search = params.get('search') || '';
        let domain = params.get('domain') || '';
        let pastProjects = params.get('past-projects') || '';

        if (el.getAttribute('name') == 'search') {
          search = el.value;
        } else if (el.getAttribute('name') == 'domain') {
          domain = el.value;
        } else if (el.getAttribute('name') == 'past-projects') {
          if (el.checked) {
            pastProjects =  pastProjects = el.value;;
          } else {
            pastProjects = '';
          }
        }

        const queryParams = new URLSearchParams();
        if (search !== '') {
          queryParams.set('search', search);
        }
        if (domain !== '') {
          queryParams.set('domain', domain);
        }
        if (pastProjects !== '') {
          queryParams.set('past-projects', pastProjects);
        }

        const link = `${window.location.origin}${window.location.pathname.split('/page/')[0]}?${queryParams.toString()}`;
        window.location.href = link;
      })
    });
  }
});
